import { elsterDocxUtils, emptyLine } from '../utils/elster_docx_utils';
import i18n from 'i18next';
import { FURTHER_REQUIREMENTS_ONE_VERSION_7, FURTHER_REQUIREMENTS_ONE_VERSION_8, FURTHER_REQUIREMENTS_TWO_VERSION_8 } from '../constants/elsterDocxConstants';
import generalTable from '../utils/generalTable';
import { bookmarkParagraphOptions, bookmarkStyle, grayTitlesMain, mainParagraphOptions } from '../styles/elsterDocStyles';
const section4 = (data, elsterVersion) => {
  const {
    t
  } = i18n;
  const {
    createBookmark,
    createTextRunInParagraph
  } = elsterDocxUtils;
  const furtherRequirementsOne = elsterVersion === 'version_7' ? FURTHER_REQUIREMENTS_ONE_VERSION_7 : FURTHER_REQUIREMENTS_ONE_VERSION_8;
  const getTableTwoIfVersion8 = () => {
    if (elsterVersion === 'version_8') {
      return [createTextRunInParagraph(t('tk_freq_4_1'), grayTitlesMain, mainParagraphOptions), generalTable(data.elster_further_requirement, FURTHER_REQUIREMENTS_TWO_VERSION_8)];
    }
    return [];
  };
  return [createBookmark(t('tk_freq_4'), 'anchor_tk_freq_4', bookmarkStyle, bookmarkParagraphOptions), generalTable(data.elster_further_requirement, furtherRequirementsOne), ...getTableTwoIfVersion8(), emptyLine];
};
export default section4;